'use client';

import { Item } from '@snack-uikit/breadcrumbs';
import { Layout } from 'src/layout';
import { HeroZero } from 'src/snack/components/HeroZero';
import { ProductsCatalog } from 'src/snack/components/ProductsCatalog';
import {
  type CatalogProduct,
  type ProductCategory,
} from 'src/types/backendContent';

import s from './Products.module.scss';

const BREADCRUMBS: Item[] = [
  { id: 'main', label: 'Главная', href: '/' },
  { id: 'catalog', label: 'Каталог сервисов' },
];

type ProductProps = {
  platforms: CatalogProduct['productPlatforms'];
  categories: ProductCategory[];
  products: CatalogProduct[];
};

export function ProductsPage({
  platforms,
  categories,
  products,
}: ProductProps) {
  return (
    <Layout>
      <div className={s.root}>
        <HeroZero
          title="Каталог сервисов"
          description="IaaS, PaaS и ML сервисы"
          breadcrumbs={BREADCRUMBS}
        />
        <ProductsCatalog
          platforms={platforms}
          categories={categories}
          products={products}
        />
      </div>
    </Layout>
  );
}
